import { render, staticRenderFns } from "./customerService.vue?vue&type=template&id=7b3ef12b&scoped=true&"
import script from "./customerService.vue?vue&type=script&lang=js&"
export * from "./customerService.vue?vue&type=script&lang=js&"
import style0 from "./customerService.vue?vue&type=style&index=0&id=7b3ef12b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b3ef12b",
  null
  
)

export default component.exports